import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { format } from 'date-fns';
import { onValue, ref } from 'firebase/database';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Input } from 'reactstrap';

import CarouselStudent from './../ChecklistEditorStudent/CaruselStudent';
import PopupChecklistFile from './PopupChecklistFile';
import iconNotebook from '../../assets/img/icon-notebook-stud.svg';
import {
  setStudentPhotoExum,
  deletStudentPhotoExum,
  setItemPointExumChecked,
  getTeacher,
  setStudentDateCompleted,
  subjectsObj,
  setStudentDateEndExam,
  setOpenMaterialFlag,
} from '../../Common/Database';
import { database } from '../../Common/Firebase';
import { convertImageToWebp } from '../../Common/MediaConverter';
import { setIndexAcardionItem, getIndexAcardionItem } from '../../redux/slices/checklistStudentSlice';
import { getProgressFile } from '../../redux/slices/uploadFileSlice';
import { setObjectHomework, getUserType } from '../../redux/slices/userSlice';
import StudentHomeworkItem from '../CreateHomework/StudentHomeworkItem';

import './style.scss';
import classNames from 'classnames';

const ChecklistEditor = ({ mail }) => {
  const [examItem, setExamItem] = useState({});

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupContentFile, setIsPopupContentFile] = useState({});
  const [nameTeacher, setNameTeacher] = useState(null);
  const [exam, setExam] = useState({});

  const fileProgressSelector = useSelector(getProgressFile);
  const userType = useSelector(getUserType);
  const activeIndex = useSelector(getIndexAcardionItem);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location && location.state && mail) {
      try {
        const dbRef = ref(database, `Students/${mail}/materials/${location.state ? location.state.id : examItem.id}`);

        const unsubscribe = onValue(dbRef, snapshot => {
          const obj = snapshot.val();
          if (JSON.stringify(obj) !== JSON.stringify(examItem)) {
            setExamItem(obj);
          }
        });

        return () => {
          unsubscribe();
        };
      } catch (error) {
        console.error('Ошибка при работе  Firebase:', error);
      }
    }
  }, [location, mail]);

  useEffect(() => {
    if (examItem && examItem.mail) {
      const teacherDate = async () => {
        try {
          const response = await getTeacher(examItem.mail);
          const resp = response.val();

          if (resp) {
            setNameTeacher(resp.FIO);
          }
        } catch (error) {
          console.error('Ошибка при получении данных учителя:', error);
        }
      };

      const exemObj = () => {
        setExam(examItem);
      };

      teacherDate();
      exemObj();
    }
  }, [examItem.mail]);

  const currentDate = format(new Date(), 'dd.MM.yyyy');

  const handleFileUpload = async (event, purentIndex, pointIndex) => {
    event.stopPropagation();
    let file = event.target.files[0];

    if (file && file['type'].split('/')[0] === 'image') {
      file = await convertImageToWebp(URL.createObjectURL(file), file);
    }

    if (file) {
      setStudentPhotoExum(file, file.name, mail, examItem, purentIndex, pointIndex);
    }
  };

  const openPopupFile = item => {
    setIsPopupContentFile(item);
    setIsPopupOpen(true);
  };

  const colsePopupFile = () => {
    setIsPopupContentFile({});
    setIsPopupOpen(false);
  };

  const openPopupFileFunc = (e, file) => {
    if (!e.target.closest('.delet-file')) {
      openPopupFile(file);
    }
  };

  const goToNotebook = (currentMail, subject, item, indexItem) => {
    if (userType === 'Student') {
      dispatch(
        setObjectHomework({
          item: item,
          number: indexItem,
          examItem: examItem,
          nameItem: examItem.name + ' №' + (indexItem + 1),
        }),
      );
      navigate(`/notebook/${currentMail}/${subjectsObj[subject]}/Homework`);
    }
  };

  return (
    <div className="student-carusel student-page">
      <div className={fileProgressSelector > 0 ? 'progress-loader-wrap active' : 'progress-loader-wrap '}>
        <div className="progress-loader-item">
          <div className="progress-loader-content" style={{ width: fileProgressSelector + '%' }}>
            <span>{fileProgressSelector}%</span>
          </div>
        </div>
      </div>

      <CarouselStudent>
        <div key={0} className="materials-page checklist-page imageSlide container">
          <div className="title-wrap">
            <h1>
              {t('checklist')} №<span>{examItem.examNumber}</span>
            </h1>

            <div className="cource-name">
              <h3>
                {t('subject')} {t(examItem.subject)}
              </h3>
            </div>

            <div className="cource-name">
              <h3>
                {t('Cource name')}: <span>{examItem.name}</span>
              </h3>
            </div>

            <div className="date-wrap">
              <div className="wrap-picker">
                <span className="title">
                  <span>{t('start date')} </span>
                  <div className="checked-item completed start-date">{examItem.startDateExam}</div>
                </span>
                <div className="wrap-picker-title"></div>
              </div>
              <div className="wrap-picker">
                <span className="title">
                  <span>{t('end date')} </span>
                  <div className="checked-item completed end-date">
                    <Input
                      className="homework-checkbox-input"
                      checked={
                        examItem && examItem.courseCompletion && examItem.courseCompletion.studentEndExamCheked
                          ? true
                          : false
                      }
                      onChange={e => setStudentDateEndExam(e, mail, examItem)}
                      type="checkbox"
                    />
                    {examItem &&
                    examItem.courseCompletion &&
                    examItem.courseCompletion.studentEndExamCheked &&
                    examItem.courseCompletion.studentEndExam
                      ? examItem.courseCompletion.studentEndExam
                      : currentDate}
                  </div>
                </span>

                <div className="wrap-picker-title"></div>
              </div>
            </div>
          </div>
          <div className="checlist-content">
            <p>
              {t(
                'This is a control sheet. It contains tasks that you need to complete in turn. Put the date and your signature when you completed the task on the dash next to the task.',
              )}
            </p>
            <p>
              {t(
                'Whenever you come across a word that you do not understand or the meaning of which you are not sure, consult a dictionary.',
              )}
            </p>
            <p>{t('If you have any questions, please contact your supervisor.')}</p>
            <p>
              {t('A supervisor is the head of the course and is there to help you get the most out of the course.')}
            </p>
            <div className="purpose-wrap">
              <div className="cource-purpose">
                <h3>
                  {t('Purpose of the course')}: <span>{examItem.purpose}</span>
                </h3>
              </div>

              <div className="cource-purpose">
                <h3>
                  {t('Prerequisites')}: <span>{examItem.conditions}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>

        {examItem &&
          examItem.chapter &&
          examItem.chapter.length > 0 &&
          examItem.chapter.map((slide, index) => {
            return (
              <div key={index + 1} className="materials-page checklist-page imageSlide container">
                <div className="slide">
                  <div className="checklist-item">
                    <div className="data-course">
                      <span className="subject">
                        {t('subject')} {t(examItem.subject)}
                      </span>
                      <span className="checklist-numb">
                        {t('checklist')} №{examItem.examNumber}
                      </span>
                    </div>
                    <h1>
                      {t('Chapter')} {index + 1}.
                    </h1>
                    <div className="checklist-item-top">
                      <h3>{t('materials')}:</h3>
                      <ul>
                        {slide.materials &&
                          slide.materials.map((materialItem, materIndex) => {
                            return materialItem.url ? (
                              <li
                                key={materialItem.id}
                                onClick={() => {
                                  if (materialItem.url) {
                                    console.log('material!', materialItem);
                                    window.open(materialItem.url, '_blank');
                                  }
                                }}
                              >
                                <span className="material-numb">{materIndex + 1}.</span>
                                <div className="icon">
                                  <img src={iconNotebook} alt="icon" />
                                </div>
                                <div
                                  className={classNames('wrap', {
                                    'without-link': materialItem.url === '',
                                  })}
                                >
                                  <p>{materialItem.title}</p>
                                </div>
                              </li>
                            ) : (
                              <li key={materialItem.id}>
                                <span className="material-numb">{materIndex + 1}.</span>
                                <div className="icon">
                                  <img src={iconNotebook} alt="icon" />
                                </div>
                                <div className={classNames('wrap')}>
                                  <Link
                                    style={{ color: 'black' }}
                                    onClick={() =>
                                      setOpenMaterialFlag(mail, 'materials', materialItem.studentMaterial.id)
                                    }
                                    to={`/materialView?id=${
                                      materialItem && materialItem.studentMaterial && materialItem.studentMaterial.id
                                    }`}
                                    target="_blank"
                                  >
                                    <p>{materialItem.title}</p>
                                  </Link>
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </div>

                    {slide.points.map((pointItem, pointIndex) => {
                      return (
                        <div key={index + pointIndex + index + slide.chapterNum} className="checklist-item-content">
                          <div
                            className="title-wrap"
                            onClick={() => {
                              if (activeIndex === pointIndex + index + slide.chapterNum) {
                                dispatch(setIndexAcardionItem(null));
                              } else {
                                dispatch(setIndexAcardionItem(pointIndex + index + slide.chapterNum));
                              }
                            }}
                          >
                            <h3>{`${t('point')} №${pointIndex + 1}${pointItem.star ? '*' : ''}`}</h3>
                            <span
                              className={classNames('icon icon-chevron-down', {
                                revert: activeIndex === pointIndex + index + slide.chapterNum,
                              })}
                            ></span>
                          </div>

                          <div
                            className={`wrap-exum ${
                              activeIndex === pointIndex + index + slide.chapterNum ? 'open' : ''
                            }`}
                          >
                            <StudentHomeworkItem content={JSON.parse(pointItem.content)} checklist />
                          </div>

                          <div className="block-bottom">
                            <div className="data-row">
                              <div className="data-row-item">
                                <h4>{t('Task completed')}</h4>

                                <div className="checked-item completed">
                                  <Input
                                    className="homework-checkbox-input"
                                    checked={pointItem.itemComplited ? true : false}
                                    onChange={e => setItemPointExumChecked(e, mail, examItem, index, pointIndex)}
                                    type="checkbox"
                                  />
                                  {pointItem.itemComplited && pointItem.dataItemComplited
                                    ? pointItem.dataItemComplited
                                    : currentDate}
                                </div>
                              </div>

                              <div className="data-row-item">
                                <h4>{t('Task checked')}</h4>

                                <div className="checked-item checked">
                                  <Input
                                    className="homework-checkbox-input"
                                    checked={pointItem.itemVerification ? true : false}
                                    onChange={e => console.log(e)}
                                    type="checkbox"
                                  />
                                  {pointItem.itemVerification && pointItem.dataItemVerification
                                    ? pointItem.dataItemVerification
                                    : currentDate}
                                </div>
                              </div>
                            </div>

                            <div className="block-buttons">
                              <div className="file-upload">
                                <div className="file-upload-content">
                                  <PhotoCameraIcon className="camera" size={20} />
                                  <h4>{t('add-photo')}</h4>
                                </div>
                                <input
                                  className="file-upload-input"
                                  type="file"
                                  onChange={e => handleFileUpload(e, index, pointIndex)}
                                />
                              </div>

                              {pointItem.notebookLink && (
                                <Button
                                  className="to-notebook"
                                  onClick={e => goToNotebook(mail, examItem.subject, pointItem, pointIndex)}
                                >
                                  {t('to-notebook')}
                                </Button>
                              )}
                            </div>
                          </div>

                          <div className="file-items">
                            {pointItem.fileItems &&
                              pointItem.fileItems.map((file, fileIndex) => (
                                <div className="wrap-img" onClick={e => openPopupFileFunc(e, file)}>
                                  <button
                                    className="delet-file"
                                    onClick={e => deletStudentPhotoExum(file, mail, examItem, index, pointIndex)}
                                  >
                                    <DeleteForeverIcon />
                                  </button>
                                  <img
                                    key={fileIndex}
                                    src={file} // предполагая, что file содержит URL изображения
                                    alt={`file-${fileIndex}`}
                                  />
                                </div>
                              ))}
                          </div>

                          <div className="comments">
                            {pointItem.comments && (
                              <div>
                                <h5>{t('comments')}</h5>
                                {pointItem.comments.map((item, commentIndex) => (
                                  <div key={commentIndex} className="comment-wrap">
                                    <div className="wrap-teacher-name">
                                      <span className="teacher-name">{nameTeacher}</span>
                                      <span className="comment-time">{item.commentTime}</span>
                                    </div>
                                    <p>{item.pointComment}</p>
                                    <button
                                      className="delet-file"
                                      onClick={() =>
                                        deleteCommentExem(
                                          location.state.studentId,
                                          examItem,
                                          index,
                                          pointIndex,
                                          commentIndex,
                                          setExamItem,
                                        )
                                      }
                                    >
                                      <DeleteForeverIcon />
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <PopupChecklistFile isOpen={isPopupOpen} onClose={() => colsePopupFile()}>
                  <div className="wrap-file-popup">
                    <img src={isPopupContentFile} alt="img-file" />
                  </div>
                  {/* Other content... */}
                </PopupChecklistFile>
              </div>
            );
          })}

        <div key={3} className="materials-page checklist-page imageSlide last-slide container">
          <div className="title-wrap">
            <div className="data-course">
              <span className="subject">
                {t('subject')} {t(examItem.subject)}
              </span>
              <span className="checklist-numb">
                {t('checklist')} №{examItem.examNumber}
              </span>
            </div>
            <h1>{t('Completion of the course')}</h1>

            <ul className="last-page-list">
              <li>
                <h3>{t('Student')}</h3>
                <p>
                  {t(
                    'I have studied all the material to be studied and completed all the exercises on this checklist, and I can apply all the information I have learned in this course.',
                  )}
                </p>
                <div className="data-row-item">
                  <h4>{t('date')}</h4>

                  <div className="checked-item completed">
                    <Input
                      className="homework-checkbox-input"
                      checked={
                        examItem && examItem.courseCompletion && examItem.courseCompletion.studentCheked ? true : false
                      }
                      onChange={e => setStudentDateCompleted(e, mail, examItem)}
                      type="checkbox"
                    />
                    {examItem &&
                    examItem.courseCompletion &&
                    examItem.courseCompletion.studentCheked &&
                    examItem.courseCompletion.student
                      ? examItem.courseCompletion.student
                      : currentDate}
                  </div>
                </div>
              </li>

              <li>
                <h3>{t('Supervisor')}</h3>
                <p>
                  {t(
                    'I certify that I have made every effort to teach this student and that he has studied all the material in this course and is able to apply the information he has learned.',
                  )}
                </p>
                <div className="data-row-item">
                  <h4>{t('date')}</h4>

                  <div className="checked-item exam">
                    <Input
                      className="homework-checkbox-input"
                      checked={
                        examItem && examItem.courseCompletion && examItem.courseCompletion.supervisorCheked
                          ? true
                          : false
                      }
                      onChange={e => console.log(e)}
                      type="checkbox"
                    />
                    {examItem &&
                    examItem.courseCompletion &&
                    examItem.courseCompletion.supervisorCheked &&
                    examItem.courseCompletion.supervisor
                      ? examItem.courseCompletion.supervisor
                      : currentDate}
                  </div>
                </div>
              </li>

              <li>
                <h3>{t('Course examiner')}</h3>
                <p>
                  {t(
                    'Checks that the checklist is completely filled out and that the student has completed everything required in this course.',
                  )}
                </p>
                <div className="data-row-item">
                  <h4>{t('date')}</h4>

                  <div className="checked-item checked">
                    <Input
                      className="homework-checkbox-input"
                      checked={
                        examItem && examItem.courseCompletion && examItem.courseCompletion.examenerCheked ? true : false
                      }
                      onChange={e => console.log(e)}
                      type="checkbox"
                    />
                    {examItem &&
                    examItem.courseCompletion &&
                    examItem.courseCompletion.examenerCheked &&
                    examItem.courseCompletion.examener
                      ? examItem.courseCompletion.examener
                      : currentDate}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </CarouselStudent>
    </div>
  );
};

export default ChecklistEditor;
